"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var CheckoutOrder = function () {
    var _a = (0, react_hook_form_1.useForm)(), handleSubmit = _a.handleSubmit, register = _a.register, setValue = _a.setValue;
    var _b = (0, react_i18next_1.useTranslation)(), t = _b.t, i18n = _b.i18n;
    var _c = (0, react_1.useState)(true), isConditionAccept = _c[0], setIsConditionAccept = _c[1];
    var _d = (0, react_1.useState)(), orderHashId = _d[0], setOrderHashId = _d[1];
    var _e = (0, react_1.useState)('#'), url = _e[0], setUrl = _e[1];
    var _f = (0, react_1.useState)(false), isRequest = _f[0], setIsRequest = _f[1];
    var _g = (0, react_1.useState)(false), isButtonDis = _g[0], setIsButtonDis = _g[1];
    var onSubmit = function (data) {
        setIsRequest(true);
        axios_1.default.post("/app/order/to-payment", data)
            .then(function (response) {
            console.log(response.data);
            if (response.status == 200) {
                if (response.data.redirect)
                    window.location.href = response.data.redirect;
            }
        }).catch(function (error) {
            console.log("error", error);
        }).finally(function () {
            setTimeout(function () {
                setIsRequest(false);
            }, 1000);
        });
    };
    (0, react_1.useEffect)(function () {
        var formNode = document.getElementById("react-payment-order");
        var hash = formNode === null || formNode === void 0 ? void 0 : formNode.getAttribute('data-hash-id');
        var urlLink = formNode === null || formNode === void 0 ? void 0 : formNode.getAttribute('data-link-url');
        if (hash) {
            setOrderHashId(hash);
            setValue('order_hash_id', hash);
        }
        if (urlLink) {
            setUrl(urlLink);
        }
        console.log('ads');
    }, []);
    (0, react_1.useEffect)(function () {
        if (!isConditionAccept) {
            setIsButtonDis(true);
        }
        else {
            setIsButtonDis(false);
        }
        if (isRequest) {
            setIsButtonDis(true);
        }
    }, [isConditionAccept, isRequest]);
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("form", { onSubmit: handleSubmit(onSubmit) },
            react_1.default.createElement("div", { className: "__order-checkout" },
                react_1.default.createElement("input", __assign({ type: "hidden" }, register('order_hash_id'))),
                react_1.default.createElement("span", { className: "__comment" }, t("order.payment.comment.caption")),
                react_1.default.createElement("textarea", __assign({}, register('user_comment'), { placeholder: t("order.payment.comment.placeholder") }))),
            react_1.default.createElement("div", { className: "__wrap-checkout-button" },
                react_1.default.createElement("div", { className: "__wrap-condition" },
                    react_1.default.createElement("input", __assign({}, register('condition', {
                        required: true,
                        onChange: function (e) { return setIsConditionAccept(e.target.checked); }
                    }), { defaultChecked: isConditionAccept, className: "custom-checkbox", type: "checkbox", id: "color-1" })),
                    react_1.default.createElement("label", { htmlFor: "color-1" }, t("order.payment.condition.label"))),
                react_1.default.createElement("div", { className: "__wrap-button" },
                    react_1.default.createElement("a", { className: "__change-order", href: url }, t("order.payment.change.link")),
                    react_1.default.createElement("button", { type: "submit", disabled: isButtonDis, className: "__to-checkout" },
                        t("order.payment.checkout.submit"),
                        !isButtonDis
                            ? react_1.default.createElement("img", { src: "/images/app/checkout-button.svg" })
                            : react_1.default.createElement("img", { src: "/images/app/checkout.svg" })))))));
};
exports.default = CheckoutOrder;
